module.exports = __webpack_public_path__ + "f9878248deb232bc986464cd7d05af09.png";